<template>
  <div class="row mb-4">
    <div class="col-12 row">
      <h2>{{ $t('autocaller_v2.monitoring.tasks.topic') }}</h2>
      <h2 class="offset-2 mb-4 text-decoration-underline">{{ $t('autocaller_v2.monitoring.tasks.all') }}: {{ tasks.length }}</h2>
    </div>
    <div class="mr-4" v-for="item in computedState" :key="item.state">
      <badge-status :state='item.state' body_class="task--state">
        <h4 class="mb-0">{{ item.counter }} {{ item.name }}</h4>
      </badge-status>
    </div>
  </div>
</template>

<script>
  import BadgeStatus from './monitoring-badge-status'
  export default {
    components: {
      BadgeStatus
    },
    props: {
      tasks: {
        type: [Array, String],
        default: () => []
      },
      state: {
        type: [Object, Array],
        default: () => {}
      }
    },
    computed: {
      computedState() {
        let state= this.state;
        this.state.forEach((stat, i=0) => {
          state[i++].counter = this.tasks.filter( o => o.state == stat.state).length
        });
        return state;
      },
      pending() {
        return this.tasks.filter(function(value) {
          return value.state === 'pending';
        }).length 
      },
      connected() {
        return this.tasks.filter(function(value) {
          return value.state === 'connected';
        }).length 
      },
      dialing() {
        return this.tasks.filter(function(value) {
          return value.state === 'dialing';
        }).length 
      },
      active() {
        return this.tasks.filter(function(value) {
          return value.state === 'active';
        }).length 
      },
      processing() {
        return this.tasks.filter(function(value) {
          return value.state === 'processing';
        }).length 
      }
      // checking() {
      //   return this.tasks.filter(function(value) {
      //     return value.state === 'checking';
      //   }).length 
      // }
    }
  }
</script>